import isEqual from 'lodash.isequal'

export default {
  inject: ['tableFilterable'],
  watch: {
    'tableFilterable.filters' (newFilters, currentFilters) {
      if (isEqual(currentFilters, newFilters) || !this.gridOptions.api) return

      this.gridOptions.api.setFilterModel(newFilters)
    },
    'tableFilterable.searchTerm' (newSearchTerm) {
      if (!this.gridOptions.api) return

      this.gridOptions.api.setGridOption('quickFilterText', newSearchTerm)
    }
  },
  methods: {
    _setupFilter () {
      this._tableFilterable_applyFilters()
      this.gridOptions.api.addEventListener('filterChanged', this._tableFilterable_onFilterChanged)
    },
    _tableFilterable_applyFilters () {
      this.gridOptions.api.setFilterModel(this.tableFilterable.filters)
      this.gridOptions.api.setGridOption('quickFilterText', this.tableFilterable.searchTerm)
    },
    _tableFilterable_onFilterChanged () {
      if (this.loading) return

      const currentFilters = this.gridOptions.api.getFilterModel()
      const currentSearchTerm = this.gridOptions.api.getQuickFilter()

      if (!isEqual(currentFilters, this.tableFilterable.filters)) {
        this.tableFilterable.filters = currentFilters
      }

      if (currentSearchTerm !== this.tableFilterable.searchTerm) {
        this.tableFilterable.searchTerm = currentSearchTerm
      }
    }
  }
}
